import { onMounted } from "vue";
import { useAppNotificationStore } from "../store/app-notification.store";
import { useAuthStore } from "@pasta/front-auth-v2";
import { usePastaWebsocket } from "./usePastaWebsocket";

export function useAppNotificationEvents() {
  onMounted(async () => {
    const appNotificationStore = useAppNotificationStore();
    const ws = usePastaWebsocket();
    const authStore = useAuthStore();

    ws.on("app-notification", "onAppNotification", async (event: any) => {
      if (event.userId !== authStore.currentUser?.id) return;
      await appNotificationStore.getMine();
      if (Notification.permission === "granted") {
        new Notification("Nouvelle notification sur le parapheur", {
          body: event.notification.mainMessage,
        });
      }
    });
  });
}
